import { useParams } from "wouter";
import React, { Fragment, useContext, useEffect, useState } from 'react'
import { Menu, Popover, Transition } from '@headlessui/react'
import {
  AcademicCapIcon,
  BanknotesIcon,
  Bars3Icon,
  BellIcon,
  CheckBadgeIcon,
  ClockIcon,
  ReceiptRefundIcon,
  UsersIcon,
  XMarkIcon,
  DocumentIcon,
  DocumentChartBarIcon,
  PaperClipIcon
} from '@heroicons/react/24/outline'
import { AuthContext } from "../contexts/auth"
import { fetchEmployees } from '../services/api'
import { Link } from "wouter";
import ResourceHeader from "../components/resource_header";
import CuTable from "../components/cu_table";
import BusteTable from "../components/buste_table";
import DocsTable from "../components/docs_table";
import DipendentiTable from "../components/dipendenti_table";
import Navbar from "../components/navbar";
import BackButton from "../components/back_button";

import Modal from '../components/modal'
import CardCaricaBp from '../components/card_carica_bp'
import CardCaricaCu from '../components/card_carica_cu'
import TourUtente from '../components/tour_utente'
import { useAtom } from "jotai";
import { currentPageStore } from "../stores/mainStore";
import CheckPermissions from "../components/check_permissions";
import PopoverComponentCustom from "../components/popover_component";



export default function ResourceList() {
  const { resourceType } = useParams();
  const [isOpen, setIsOpen] = useState(false)
  const [forceFetch, setForceFetch] = useState(0);

  const [currentPage, setCurrentPage] = useAtom(currentPageStore)

  useEffect(() => {
    if (resourceType) {
      setCurrentPage(resourceType)
    }
  }, [resourceType])



  const { profile, token } = useContext(AuthContext)

  const isProfileComplete = profile.has_complete_profile;

  const closeIt = (val) => {
    setIsOpen(val)
    if(isOpen && !val) {
      setForceFetch(prev => prev + 1)
    }
  };

  // const updateData = () => {
  //   console.log('updateData')
  //   // emit an event to update the data
  //   window.dispatchEvent(new Event('updateDataHR'))
  // }

  const titlesMap = {
    cu: "Lista CU",
    buste: "Lista Buste Paga",
    documenti: "Lista Documenti",
    dipendenti: "Lista Dipendenti"
  };

  return <>
    <div className="h-full">
      <PopoverComponentCustom title={titlesMap[resourceType] || ""} />

      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}
      <main className="mt-10 pb-8 h-full">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          {/* back button */}
          <div className="flex items-center my-4">
            <BackButton prevLocation={`/`} />
              
              {['cu', 'buste'].includes(resourceType || '') && 
              <button type="button" className={`inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500    focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${
                resourceType === 'cu' ? 'cuCaricoMassivo secondStepCu terzoStepCu quartoStepCu quintoStepCu tourNextStep3' : 'busteCaricoMassivo secondStepBuste terzoStepBuste quartoStepBuste quintoStepBuste tourNextStep2'
              }`}
                onClick={() => {setIsOpen(true)}}
              >
                Carica Massivamente
              </button>}
        
          </div>
          
          {/* a div with a fake table */}
          <div className="bg-white rounded-lg shadow overflow-hidden firstStepDocumenti secondStepDocumenti thirdStepDocumenti tourNextStep4" style={{ height: '100vh', overflowY: 'auto'}}>
            {/* switch case based on resourceType */}
            {resourceType === 'cu' && (
              <CheckPermissions permissionsToCheck={['hr.view_docs_all', 'hr.view_docs_ou']}>
                <CuTable loading={true} forceFetch={forceFetch} token={token} />
              </CheckPermissions>
            )}
            {resourceType === 'buste' && (
              <CheckPermissions permissionsToCheck={['hr.view_docs_all', 'hr.view_docs_ou']}>
                <BusteTable loading={true} forceFetch={forceFetch} token={token} />
              </CheckPermissions>
            )}
            {resourceType === 'documenti' && (
              <CheckPermissions permissionsToCheck={['hr.view_docs_all', 'hr.view_docs_ou']}>
                <DocsTable loading={true} token={token} />
              </CheckPermissions>
            )}
            {resourceType === 'dipendenti' && <DipendentiTable loading={true} token={token} />}
          </div>
        </div>
      </main>
      <footer>
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
          <div className="border-t border-gray-200 py-8 text-center text-sm text-gray-500 sm:text-left">
            <span className="block sm:inline">&copy; {new Date().getFullYear()} Consultala SRL</span>{' '}
            <span className="block sm:inline">All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
    { resourceType == 'buste' && <Modal isOpen={isOpen} setClose={closeIt}>
      <CardCaricaBp setClose={closeIt} />
    </Modal>}
    { resourceType == 'cu' && <Modal isOpen={isOpen} setClose={closeIt}>
      <CardCaricaCu setClose={closeIt} />
    </Modal>}
  </>;
}